module.exports = __webpack_public_path__ + "static/media/story-17.cd208a51.jpg";